exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yxp-uploader .btn[data-v-f7470474]{outline:none}.yxp-uploader .btn.upload-btn[data-v-f7470474]{width:80px;border:none;padding:4px 10px;border-radius:4px;cursor:pointer;background-color:#2fd095;color:#fff}.yxp-uploader .btn.upload-btn[data-v-f7470474]:hover{background-color:#1c976a}.yxp-uploader input[data-v-f7470474]{display:none}", ""]);

// exports
